<mat-dialog-content>
  <p>{{'We have found a more accurate address:' | translate}}</p>
  <ul>
    <li>{{fullAddress}}</li>
  </ul>
  <p>{{'Do you want to change to this address, or keep the original version?' | translate}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button [mat-dialog-close]="false" mat-flat-button id="keep_original">{{'Keep Original' | translate}}</button>
  <button [mat-dialog-close]="true" mat-flat-button color="primary" id="change">{{'Change' | translate}}</button>
</mat-dialog-actions>
